(function () {
  'use strict';

  var carousels = document.querySelectorAll('[data-home-give-carousel]');
  if (!carousels.length) return;

  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-home-give-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-home-give-slide]'));
    var prevBtn = carousel.querySelector('[data-home-give-prev]');
    var nextBtn = carousel.querySelector('[data-home-give-next]');
    var currentEl = carousel.querySelector('[data-home-give-current]');
    var totalEl = carousel.querySelector('[data-home-give-total]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-home-give-dot]'));

    if (!slides.length) return;

    var padNumber = function (n) {
      return n < 10 ? '0' + n : String(n);
    };

    if (totalEl) totalEl.textContent = padNumber(slides.length);

    var getActiveIndex = function () {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(trackCenter - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });

      return closest;
    };

    var updateChrome = function () {
      var active = getActiveIndex();

      if (currentEl) currentEl.textContent = padNumber(active + 1);

      dots.forEach(function (dot, index) {
        if (index === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (prevBtn) {
        prevBtn.setAttribute('aria-disabled', active === 0 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.setAttribute('aria-disabled', active === slides.length - 1 ? 'true' : 'false');
      }
    };

    var scrollToIndex = function (index) {
      var clamped = Math.max(0, Math.min(slides.length - 1, index));
      var slide = slides[clamped];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        scrollToIndex(index);
      });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToIndex(getActiveIndex() - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToIndex(getActiveIndex() + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        scrollToIndex(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        scrollToIndex(slides.length - 1);
      }
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(updateChrome, 60);
    });

    updateChrome();
  });
})();
